(function () {
  'use strict';
  var config = document.getElementById('CartInsuranceInitial');
  var template = document.getElementById('CartInsuranceTemplate');
  if (!config || !template || !template.content.querySelector('[data-cart-insurance]')) return;
  var sample = template.content.querySelector('[data-cart-insurance]');
  var variantId = Number(sample.dataset.variantId), productId = Number(sample.dataset.productId);
  var cart = JSON.parse(config.textContent), busy = false, locked = [], normalizationAttempt = '';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function insuranceItems(value) { return value.items.filter(function (item) { return Number(item.product_id) === productId; }); }
  function hasProducts(value) { return value.items.some(function (item) { return Number(item.product_id) !== productId; }); }
  function mount() {
    var popup = document.querySelector('#cart-popup .cart-popup-ul-top');
    if (popup && !popup.parentElement.querySelector('[data-cart-insurance]')) popup.before(template.content.cloneNode(true));
  }
  function sync(value) {
    if (value && Array.isArray(value.items)) cart = value;
    mount();
    var selected = insuranceItems(cart).length > 0;
    document.querySelectorAll('[data-insurance-toggle]').forEach(function (input) {
      input.checked = selected;
      input.disabled = busy || (!hasProducts(cart) && !selected);
    });
    // This is a per-order add-on; its regular line item remains visible, but
    // customers adjust it with the toggle instead of a quantity control.
    document.querySelectorAll('#CartDrawer a[href*="/products/shipping-protection"], #cart_form a[href*="/products/shipping-protection"]').forEach(function (link) {
      var row = link.closest('.ajaxcart__product, tr');
      if (!row) return;
      row.classList.add('insurance-line');
      var input = row.querySelector('.ajaxcart__qty-num, .cart-quantity-input');
      if (input) { input.readOnly = true; input.setAttribute('aria-label', 'Shipping insurance: one per order'); }
    });
    var items = insuranceItems(cart);
    var invalid = items.length > 1 || items.some(function (item) { return item.quantity > 1; });
    var signature = items.map(function (item) { return item.key + ':' + item.quantity; }).join('|');
    if (!busy && invalid && signature !== normalizationAttempt) {
      normalizationAttempt = signature;
      setTimeout(function () { change(true); }, 0);
    }
  }
  function lock(active) {
    busy = active;
    if (active) {
      document.documentElement.setAttribute('data-insurance-busy', '');
      document.querySelectorAll('.Checkout, .ajaxcart__qty-num, .ajaxcart__qty-adjust, .cart-quantity-input').forEach(function (node) {
        if ('disabled' in node && !node.disabled) { locked.push(node); node.disabled = true; }
      });
    } else {
      document.documentElement.removeAttribute('data-insurance-busy');
      locked.forEach(function (node) { node.disabled = false; }); locked = [];
    }
    sync();
  }
  async function request(path, payload) {
    var response = await fetch(root + path, payload ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload)
    } : { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
    var result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to update shipping insurance. Please try again.');
    return result;
  }
  async function change(selected) {
    if (busy) return;
    lock(true);
    document.querySelectorAll('[data-insurance-error]').forEach(function (node) { node.hidden = true; });
    try {
      var current = await request('cart.js');
      var items = insuranceItems(current), updates = {};
      if (selected && !hasProducts(current)) throw new Error('Add a product before adding shipping insurance.');
      if (selected && !items.length) {
        await request('cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
        current = await request('cart.js');
      } else {
        items.forEach(function (item, index) { updates[item.key] = selected && index === 0 ? 1 : 0; });
        if (items.length) current = await request('cart/update.js', { updates: updates });
      }
      sync(current);
      // Reload the full cart so discount allocations, line keys, form inputs
      // and totals are all rendered from the authoritative updated cart.
      if (document.getElementById('cart_form')) { location.reload(); return; }
      document.dispatchEvent(new CustomEvent("textual:insurance-cart-updated", { detail: current }));
      // The dropdown renderer replaces its entire contents. Restore dependent
      // UI only after that redraw, or it removes the newly updated banner.
      document.dispatchEvent(new CustomEvent('textual:cart-updated', { detail: current }));
      sync(current);
    } catch (error) {
      // A failed response can occur after Shopify committed the update.
      try { sync(await request('cart.js')); } catch (_) { sync(); }
      document.querySelectorAll('[data-insurance-error]').forEach(function (node) { node.textContent = error.message; node.hidden = false; });
    } finally { lock(false); }
  }
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-insurance-toggle]')) change(event.target.checked);
  });
  document.addEventListener('click', function (event) {
    if (busy && event.target.closest('.Checkout, .cart__checkout, .cart-quantity-add, .cart-quantity-remove, .ajaxcart_remove, .removeLineCartPop, .cart__remove')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('textual:cart-updated', function (event) { sync(event.detail); });
  window.addEventListener('load', function () {
    if (window.jQuery) {
      jQuery(document.body).on('afterGetCart.ajaxCart afterCartLoad.ajaxCart', function (event, value) { sync(value); });
      jQuery(document.body).on('afterChangeItem.ajaxCart', function (event, line, quantity, value) { sync(value); });
    }
    sync();
  });
  sync();
}());
